import React, { useState, useEffect } from 'react';

function Projects() {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('/api/projects')
            .then(res => res.ok ? res.json() : Promise.reject(res.status))
            .then(data => {
                setProjects(data ?? []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    const featuredProject = projects.find(p => p.featured);
    const regularProjects = projects.filter(p => !p.featured);

    if (loading) return (
        <div className="loading">
            <div className="loading-spinner"></div>
            Loading projects...
        </div>
    );

    return (
        <div className="section">
            <div className="section-header">
                <span className="section-label">Portfolio</span>
                <h2 className="section-title">My Projects</h2>
                <p className="section-description">
                    A collection of projects I've built to sharpen my skills and solve real problems
                </p>
            </div>

            <div className="projects-grid">
                {/* Featured Project */}
                {featuredProject && (
                    <div className="project-featured">
                        <div className="featured-image">
                            <span style={{ fontSize: '6rem' }}>{featuredProject.icon}</span>
                        </div>
                        <div className="featured-content">
                            <span className="featured-badge">
                                ⭐ Featured Project
                            </span>
                            <h3 className="featured-title">{featuredProject.title}</h3>
                            <p className="featured-description">
                                {featuredProject.description}
                            </p>
                            <div className="project-tech" style={{ marginBottom: '1.5rem' }}>
                                {featuredProject.technologies.map((tech, index) => (
                                    <span key={index} className="tech-tag">{tech}</span>
                                ))}
                            </div>
                            <div className="hero-buttons">
                                <a 
                                    href={featuredProject.github}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary"
                                >
                                    View Code →
                                </a>
                                {featuredProject.demo && (
                                    <a 
                                        href={featuredProject.demo}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline"
                                    >
                                        Live Demo
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Regular Projects */}
                {regularProjects.map(project => (
                    <div key={project.id} className="project-card">
                        <div className="project-header">
                            <div className="project-icon">{project.icon}</div>
                            <div className="project-links">
                                <a 
                                    href={project.github}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="project-link"
                                    title="View Code"
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                    </svg>
                                </a>
                                {project.demo && (
                                    <a 
                                        href={project.demo}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="project-link"
                                        title="Live Demo"
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/>
                                        </svg>
                                    </a>
                                )}
                            </div>
                        </div>
                        
                        <div className="project-content">
                            <h3 className="project-title">{project.title}</h3>
                            <p className="project-description">{project.description}</p>
                        </div>

                        <div className="project-footer">
                            <div className="project-tech">
                                {project.technologies.map((tech, index) => (
                                    <span key={index} className="tech-tag">{tech}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* More Projects CTA */}
            <div className="section-header" style={{ marginTop: '4rem' }}>
                <p className="section-description">
                    Want to see more of my work?
                </p>
                <a 
                    href="https://github.com/TheBCann"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                    style={{ marginTop: '1rem' }}
                >
                    View GitHub Profile →
                </a>
            </div>
        </div>
    );
}

export default Projects;
